export const state = () => ({
  socialShare: null,
  floatHelp: false,
})

export const getters = {
  socialShare(state) {
    return state.socialShare
  },
  floatHelp(state) {
    return state.floatHelp
  },
}

export const mutations = {
  setFloatHelp(state, payload) {
    state.floatHelp = payload
  },
  setSocialShare(state, payload) {
    state.socialShare = payload
  },
  socialShareSocials(state, payload) {
    state.socialShare = payload.socials.map((network) => ({
      network,
      ...payload.options,
    }))
  },
}
